<template>
    <div class="date-picker">
        <div
            class="input-wrapper"
            @mouseenter="showCancel = true"
            @mouseleave="showCancel = false"
        >
            <div
                class="input"
                @click="togglePanel"
                v-text="range ? value[0] === '' && value[1] === '' ? '（未選択）' : value[0] + ' ～ ' + value[1] : value"
            />
            <div
                v-if="!range"
                class="vsTeam"
                @click="togglePanel"
            >
                （{{ vsTeam }}）
            </div>
            <!-- <transition name="fade">
                <img class="cancel-btn" src="./cancel.png" v-show="range" @click="clear">
            </transition> -->
            <v-touch
                tag="p"
                @tap="togglePanel()"
            >
                <span class="icon-calendar" />
            </v-touch>
        </div>
        <transition name="toggle">
            <div
                v-show="panelState"
                id="layerClose"
                class="date-panel-layer"
                @click="close($event)"
            />
        </transition>

        <transition name="toggle">
            <div
                v-show="panelState"
                class="date-panel"
                :style="coordinates"
            >
                <div
                    v-show="panelType !== 'year'"
                    class="panel-header"
                >
                    <div
                        class="arrow-left"
                        @click="prevMonthPreview()"
                    >
                        &lt;
                    </div>
                    <div class="year-month-box">
                        <div
                            class="year-box"
                            v-text="tmpYear"
                        />
                        <div class="month-box">
                            {{ tmpMonth + 1 | month(language) }}
                        </div>
                        <!-- <div class="year-box" @click="chType('year')" v-text="tmpYear"></div>
                        <div class="month-box" @click="chType('month')">{{tmpMonth + 1 | month(language)}}</div> -->
                    </div>
                    <div
                        class="arrow-right"
                        @click="nextMonthPreview()"
                    >
                        &gt;
                    </div>
                </div>
                <div
                    class="btnClose"
                    @click="close($event)"
                >
                    <span id="btnClose" />
                </div>
                <div
                    v-show="panelType === 'year'"
                    class="panel-header"
                >
                    <div
                        class="arrow-left"
                        @click="chYearRange(0)"
                    >
                        &lt;
                    </div>
                    <div class="year-range">
                        <span v-text="yearList[0]" /> - <span v-text="yearList[yearList.length - 1]" />
                    </div>
                    <div
                        class="arrow-right"
                        @click="chYearRange(1)"
                    >
                        &gt;
                    </div>
                </div>
                <div
                    v-show="panelType === 'year'"
                    class="type-year"
                >
                    <ul class="year-list">
                        <li
                            v-for="item in yearList"
                            :class="{selected: isSelected('year', item), invalid: validateYear(item)}"
                            @click="selectYear(item)"
                            v-text="item"
                        />
                    </ul>
                </div>
                <div
                    v-show="panelType === 'month'"
                    class="type-month"
                >
                    <ul class="month-list">
                        <li
                            v-for="(item, index) in monthList"
                            :class="{selected: isSelected('month', index), invalid: validateMonth(index)}"
                            @click="selectMonth(index)"
                        >
                            {{ item | month(language) }}
                        </li>
                    </ul>
                </div>
                <div
                    v-show="panelType === 'date'"
                    class="type-date"
                >
                    <ul class="weeks">
                        <li v-for="item in weekList">
                            {{ item | week(language) }}
                        </li>
                    </ul>
                    <ul class="date-list">
                        <li
                            v-for="(item, index) in dateList"
                            :class="{preMonth: item.previousMonth, nextMonth: item.nextMonth,
                                     invalid: validateDate(item), firstItem: (index % 7) === 0}"
                        >
                            <div
                                v-if="item.gameList !== undefined || range === true"
                                @click="selectDate(item)"
                            >
                                <div
                                    v-if="item.gameList !== undefined"
                                    class="message clickable"
                                    :class="{selected: isSelected('date', item)}"
                                >
                                    <div class="bg" />
                                    <span v-text="item.value" />
                                    <div
                                        v-for="d in item.gameList"
                                        class="vsTeam"
                                    >
                                        <div
                                            v-if="d.level === 'NPB' || d.level === 'AAA'"
                                            class="vsTeamInner levelNPB"
                                            :class="{isHome:d.is_home_match}"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                        <div
                                            v-else-if="d.level === 'NPB Minors' || d.level === 'AA'"
                                            class="vsTeamInner levelNPBMinors"
                                            :class="{isHome:d.is_home_match}"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                        <div
                                            v-else-if="d.level === 'NPB Minors2' || (d.level !== 'AAA' && d.level !== 'AA')"
                                            class="vsTeamInner levelNPBMinors2"
                                            :class="{isHome:d.is_home_match}"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="message"
                                    :class="{selected: isSelected('date', item)}"
                                >
                                    <div class="bg" />
                                    <span v-text="item.value" />
                                    <div
                                        v-for="d in item.gameList"
                                        class="vsTeam"
                                    >
                                        <div
                                            v-if="d.level === 'NPB'"
                                            class="vsTeamInner levelNPB"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                        <div
                                            v-else-if="d.level === 'NPB Minors'"
                                            class="vsTeamInner levelNPBMinors"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                        <div
                                            v-else-if="d.level === 'NPB Minors2'"
                                            class="vsTeamInner levelNPBMinors2"
                                        >
                                            {{ d.vsTeam }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="message">
                                    <div class="bg" /><span v-text="item.value" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div
                    class="datepickerMessageModal"
                    :class="{show: messageModalShow}"
                    @click="messageModalOff($event)"
                    v-html="message"
                />
                <div
                    id="btnDecide"
                    class="btnDecide"
                    @click="decide($event)"
                >
                    決定
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import CommonUtilityDatepicker3dSearch from '@/components_common/utility/Datepicker3dSearch.vue'

export default {
    name: 'DatePicker3dSearch',
    mixins: [CommonUtilityDatepicker3dSearch],
}
</script>

<style scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.date-picker {
  height: 30px;
  width: auto;
}
.input-wrapper {
  float: left;
  width: 320px;
  vertical-align: middle;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: center;
  padding: 6px 0 6px 10px;
  height: 32px;
  box-sizing: border-box;
  background: #555555;
}
.input {
  height: 100%;
  width: 320px;
  font-size: 1.5rem;
  padding-top: 2px;
  box-sizing: border-box;
  outline: none;
}
.cancel-btn {
  height: 14px;
  width: 14px;
  padding-right: 10px;
}
.icon-calendar {
  width: 24px;
  height: 24px;
  font-size: 22px;
  padding-right: 5px;
  color: #bbbbbb;
}
.date-picker .btn.datepickerBtn{
  float: right;
}
.date-panel-layer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  background: rgba(0,0,0,0.7);
  z-index: 100;
}
.date-panel {
  position: absolute;
  left: 50vw;
  top: 50%;
  z-index: 5000;
  border: 1px solid #eee;
  border-radius: 4px;
  width: 720px;
  padding: 5px 10px 10px;
  margin: -160px 0 0 -360px;
  box-sizing: border-box;
  background-color: #fff;
  color: #000000;
}
.panel-header {
  display: flex;
  flex-flow: row nowrap;
  width: 50%;
  margin: 0 auto;
}
.arrow-left,
.arrow-right {
  flex: 1;
  font-size: 20px;
  line-height: 2;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
}
.year-range {
  font-size: 20px;
  line-height: 2;
  flex: 3;
  display: flex;
  justify-content: center;
}
.year-month-box {
  flex: 3;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
}
.type-year,
.type-month,
.date-list {
  background-color: #fff;
}
.year-box,
.month-box {
  transition: all ease .1s;
  flex: 1;
  text-align: center;
  font-size: 20px;
  line-height: 2;
  /*cursor: pointer;*/
  background-color: #fff;
}
.year-list,
.month-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.year-list li,
.month-list li {
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  width: 33%;
  padding: 10px 0;
}
.year-list li:hover,
.month-list li:hover {
  background-color: #6ac1c9;
  color: #fff;
}
.year-list li.selected,
.month-list li.selected {
  background-color: #3c5992;
  color: #fff;
}
.year-list li.invalid,
.month-list li.invalid {
  cursor: not-allowed;
  color: #ccc;
}
.date-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.date-list .valid:hover {
  background-color: #eee;
}
.date-list li {
  transition: all ease .1s;
  cursor: pointer;
  box-sizing: border-box;
  border-bottom: 1px solid #fff;
  position: relative;
  margin: 2px;
}
.date-list li:not(.firstItem) {
  /*margin-left: 10px;*/
}
.date-list li .message {
  font-weight: 300;
  font-size: 14px;
  position: relative;
  height: 32px;
}
.date-list li .message.clickable{
  border: 1px solid #3c5992;
  border-radius: 3px;
}
.date-list li .message.clickable.selected{
  border: none;
}
.date-list li .message.selected .bg {
  background-color: #3c5992;
}
.date-list li .message.selected span{
  color: #fff;
  font-weight: normal;
}
.date-list li .message.selected .vsTeam .vsTeamInner.levelNPBMinors2{
  background: none;
  color: #fff;
}
.date-list li .message.selected .vsTeam .vsTeamInner.levelBullpen{
  background: none;
  color: #fff;
}
.date-list li .message:not(.selected) .bg {
  transform: scale(0);
  opacity: 0;
}
.date-list li .message:not(.selected):hover .bg {
  /*background-color: #3c5992;
  transform: scale(1);
  opacity: .6;*/
}
.date-list li .message:not(.selected):hover span,
.date-list li .message:not(.selected):hover .vsTeam {
  /*color: #fff;*/
}
.date-list li .message .bg {
  height: 30px;
  width: 100%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border-radius: 3px;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
}
.date-list li .message span {
  position: absolute;
  z-index: 20;
  left: 48%;
  top: 22%;
  transform: translate3d(-50%, -50%, 0);
  font-weight: bold;
}
.date-list li .message .vsTeam{
  position: relative;
  display: inline-block;
  width: 27px;
  font-size: 1.1rem;
  margin: 0 1px;
  z-index: 11;
  /*
  position: absolute;
  z-index: 30;
  left: 50%;
  top: 72%;
  transform: translate3d(-50%, -50%, 0);
  width: 40px;
  font-size: 1.1rem;
  */
}
  .date-list li .message .vsTeam .vsTeamInner{
    position: absolute;
    left: -22%;
    top: -6px;
    display: inline-block;
    -webkit-transform: scale( 0.7, 1 );
    transform: scale( 0.7, 1 );
    -webkit-transform-origin: top center;
    transform-origin: top center;
    width: 140%;
    height: 15px;
    line-height: 140%;
    letter-spacing: 0.1rem;
    border-radius: 3px;
  }
  .date-list li .message .vsTeam .vsTeamInner.levelNPB{
    background: #f39c0e;
  }
  .date-list li .message .vsTeam .vsTeamInner.levelNPBMinors{
    background: #93aee4;
  }
  .date-list li .message .vsTeam .vsTeamInner.levelNPBMinors2{
    background: #fff;
  }
  .date-list li .message .vsTeam .vsTeamInner.levelBullpen {
    position: absolute;
    left: -60%;
    top: -6px;
    display: inline-block;
    -webkit-transform: scale( 0.5, 1 );
    transform: scale( 0.5, 1 );
    -webkit-transform-origin: top center;
    transform-origin: top center;
    width: 210%;
    height: 15px;
    line-height: 140%;
    letter-spacing: 0.1rem;
    border-radius: 3px;
    background: #ccc;
  }
  .isHome {
    border-bottom: solid 2px #000;
  }
.date-list li.invalid {
  cursor: not-allowed;
  color: #ccc;
}
.weeks {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.weeks li {
  font-weight: 600;
}
.weeks,
.date-list {
  width: 100%;
  text-align: center;
}
.weeks .preMonth,
.date-list .preMonth,
.weeks .nextMonth,
.date-list .nextMonth {
  color: #ccc;
}
.weeks li,
.date-list li {
  width: 95px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}
.toggle-enter,
.toggle-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}
.toggle-enter-active,
.toggle-leave-active {
  transition: all ease .2s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: scale3d(0, 0, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition: all ease .1s;
}

.datepickerMessageModal{
  position: absolute;
  left: 5%;
  top: 40%;
  z-index: 1001;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  visibility: hidden;
  -webkit-transition: .3s;
  transition: .3s;
  width: 90%;
  padding: 10px;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  color: #fff;
  font-size: 1.6rem;
  opacity: 0;
  line-height: 140%;
}
.datepickerMessageModal.show {
  visibility: visible !important;
  opacity: 1 !important;
}
.btnDecide{
  display: block;
  width: 100%;
  border-radius: 4px;
  background: #3c5992;
  text-align: center;
  padding: 8px 0 10px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.btnClose{
  position: absolute;
  right: 20px;
  top: 6px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.btnClose span{
  display: block;
  width: 40px;
  height: 40px;
}
.btnClose span:before,.btnClose span:after{
  display: block;
  content: '';
  width: 2px;
  height: 20px;
  -webkit-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #000;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 19px;
}
.btnClose span:after{
  -webkit-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>
